import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Home, Search, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Sidan hittades inte | Weddingly</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="Sidan du letade efter kunde inte hittas. Gå tillbaka till startsidan för att hitta det du söker." />
      </Helmet>
      
      <Header />
      
      <main className="min-h-[60vh] flex items-center justify-center bg-background px-4 py-16">
        <div className="text-center max-w-md">
          <h1 className="text-7xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            Sidan hittades inte
          </h2>
          <p className="text-muted-foreground mb-8">
            Vi kunde tyvärr inte hitta sidan du letade efter. Den kan ha flyttats eller tagits bort.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild variant="default">
              <Link to="/" className="flex items-center gap-2">
                <Home className="h-4 w-4" />
                Till startsidan
              </Link>
            </Button>
            
            <Button asChild variant="outline">
              <Link to="/leverantorer" className="flex items-center gap-2">
                <Search className="h-4 w-4" />
                Hitta leverantörer
              </Link>
            </Button>
          </div>
          
          <button 
            onClick={() => window.history.back()}
            className="mt-6 text-sm text-muted-foreground hover:text-primary flex items-center gap-1 mx-auto transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Gå tillbaka
          </button>
        </div>
      </main>
      
      <Footer />
    </>
  );
};

export default NotFound;
